'use client';

import { forwardRef, useCallback, useImperativeHandle } from 'react';
import { useI18n } from 'next-localization';

import { useFormContext } from 'react-hook-form';

import { ProvidersInputRef } from '@/features/landing/landing-search.types';
import { NeuButton } from '@hcahealthcaredpx/neutron-react';
import { UseMyLocationFields } from '@xsf/shared-lib/hooks/location';

import { useListingContext } from '../../hooks';

export const ClearFiltersButton = forwardRef(
  (
    {
      providersInputRef,
    }: {
      providersInputRef: React.RefObject<ProvidersInputRef>;
    },
    clearFiltersRef
  ): JSX.Element => {
    const { t } = useI18n();

    const { reset } = useFormContext();
    const { clearFilters } = useListingContext();

    const clearButtonHandler = useCallback(() => {
      clearFilters();
      localStorage.removeItem('user.location');
      reset({
        providerField: '',
        [UseMyLocationFields.ADDRESS]: '',
        [UseMyLocationFields.CITY]: '',
        [UseMyLocationFields.STATE]: '',
        [UseMyLocationFields.ZIP_CODE]: '',
        [UseMyLocationFields.LATITUDE]: '',
        [UseMyLocationFields.LONGITUDE]: '',
      });
      providersInputRef?.current?.clear();
    }, [providersInputRef, clearFilters, reset]);

    useImperativeHandle(clearFiltersRef, () => {
      return {
        clear() {
          clearButtonHandler();
        },
      };
    }, [clearButtonHandler]);

    return (
      <NeuButton kind="tertiary" size="small" icon="close" onNeuClick={clearButtonHandler}>
        {t('OAS.Listing.Filter.ClearButton')}
      </NeuButton>
    );
  }
);

ClearFiltersButton.displayName = 'ClearFiltersButton';
